import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";

const NestErrorLineCell: FC<
  DataTableCellChildComponentProps<NestTestResultError>
> = ({ content }) => {
  const { t } = useTranslation();
  return <>{content.line ?? t("aic_nest_history_error_table_no_line")}</>;
};

export default NestErrorLineCell;
